import { useCallback } from "react";
import {
  usePaginatedResource,
  PaginatedFetcher,
  pageFrom,
} from "./usePaginatedResource";
import { CommunityService } from "../services/communityService";
import { ReportedPost } from "../types/community";

export const useReportedPosts = (
  initialPage: number = 1,
  initialLimit: number = 30
) => {
  const fetcher = useCallback<PaginatedFetcher<ReportedPost, {}>>(
    async (page) => {
      const response = await CommunityService.getReportedPosts(page);
      if (!response) return null;

      // This endpoint uses Laravel's API-Resource envelope, so the counts
      // live under `meta` rather than beside the rows.
      return pageFrom(response.data, {
        total: response.meta.total,
        page: response.meta.current_page,
        limit: response.meta.per_page,
      });
    },
    []
  );

  const { items, ...rest } = usePaginatedResource<ReportedPost, {}>(fetcher, {
    initialPage,
    initialLimit,
    errorMessage: "Failed to fetch reported posts",
  });

  return { reportedPosts: items, ...rest };
};
